const initialState = {
	/**
	 * 
	 */
	// listChat: [],
	ws: false,
	wsContent: false,
	startWs: false,
	isWaitWs: false,
	sendWs: false,
	//Lệch closeWs
	wsClose: false,

	soundNewMsg: false,
	soundRate: false,
	soundOpenBox: false,
	screen: false,
	isWait: true,

	webSetting: false,
	soundWaitingCall: false,

};

const routerReducers = (state = initialState, { type, payload } = {}) => {
	let states = state;
	switch (type) {
		case 'LIST_CHATA':
			states = {
				...state,
				listChat: payload
			};
			break;
		case 'WS':
			states = {
				...state,
				ws: payload
			};
			break;
		case 'WS_CONTENT':
			states = {
				...state,
				wsContent: payload
			};
			break;
		case 'START_WS':
			states = {
				...state,
				startWs: payload
			};
			break;
		case 'IS_WAIT_WS':
			states = {
				...state,
				isWaitWs: payload
			};
			break;
		case 'IS_WAIT':
			states = {
				...state,
				isWait: payload
			};
			break;
		case 'SEND_WS':
			states = {
				...state,
				sendWs: payload
			};
			break;
		case 'SOUND_NEW_MSG':
			states = {
				...state,
				soundNewMsg: payload
			};
			break;
		case 'SOUND_RATE':
			states = {
				...state,
				soundRate: payload
			};
			break;
		case 'SOUND_OPEN_BOX':
			states = {
				...state,
				soundOpenBox: payload
			};
			break;
		case 'SOUND_WAITING_CALL':
			states = {
				...state,
				soundWaitingCall: payload
			};
			break;
		case 'WS_CLOSE':
			states = {
				...state,
				wsClose: payload
			};
			break;
		case 'SCREEN':
			states = {
				...state,
				screen: payload
			};
			break;
		case 'WEB_SETTING':
			states = {
				...state,
				webSetting: payload
			};
			break;
		default:
			states = state;
			break;
	}
	return states;
};

export default routerReducers;




// WEBPACK FOOTER //
// ./src/redux/reducers.js